import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/modules/auth';
import LoadingScreen from '../layout/LoadingScreen';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, twoFa } = useAuth();

    if (isLoading) {
        return <LoadingScreen />;
    }

    if (isAuthenticated && twoFa?.requiresSetup) {
        return <Navigate to="/setup-2fa" replace />;
    }

    return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;